import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {getResourcesData} from "./data/FrontPageData";

const ResourceTemplate = ({resourceData}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <Box>
        <Typography variant={'h4'} color="textSecondary">{resourceData.type}</Typography>
      </Box>
      <Box>
        <Typography variant={'h4'} color="textSecondary">{resourceData.product}</Typography>
      </Box>
    </Stack>
  )
}

const getResourceData = (resourcesData, slug) => {
  for(let resourceData of resourcesData){
    if(resourceData.slug === slug) {
      return resourceData;
    }
  }
  return null;
}

export const ResourcePage = ({}) => {
  const urlComponents = window.location.href.split('/')
  const slug = urlComponents[urlComponents.length - 1];
  const resourcesData = getResourcesData();
  const resourceData = getResourceData(resourcesData, slug);
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={resourceData.label}
        SubHeader={''}
        Alignment="left"
      />
      <ResourceTemplate
        resourceData={resourceData}
      />
    </Stack>
  );
}